
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacAlert from '@/components/BacAlert.vue'

import { Rally } from '../../lib/models/Rally'
import { RallyRound } from '../../lib/models/RallyRound'
import { Http } from '../../lib/utils/Http'

@Component({
  components: {
    BacAlert
  }
})
export default class RegistrationCheck extends Vue {
  futureRallyRounds: RallyRound[] = []
  rallies: Rally[] = []
  selectedRallyRound = 0

  finishedTeamsizeProblems = []
  notFinished = []
  duplicateTeamnumbers = []
  noTeamnumberFinished = []
  totalRegistrations = 0

  loadingProblems = true

  mounted () {
    this.loadFutureRallyRounds()
    this.loadProblems()
    this.loadRallies()
  }

  @Watch('selectedRallyRound')
  async loadProblems () {
    this.loadingProblems = true
    await Promise.all([
      await this.loadTeamsizeProblems(),
      await this.loadNotFinished(),
      await this.loadDuplicateTeamnumber(),
      await this.loadNoTeamnumber(),
      await this.loadTotalRegistrationNumber()
    ])
    this.loadingProblems = false
  }

  async loadRallies () {
    this.rallies = await Rally.getAll({})
  }

  get numberOfNotFinished () {
    return this.notFinished.length
  }

  get numberOfProblems () {
    const problems: number[] = []
    problems.push(...this.finishedTeamsizeProblems)

    // every teamnumber entry is only half a problem, because if one is fixed another one is too
    let i = 0
    this.duplicateTeamnumbers.forEach(problem => {
      if (!problems.find(p => p === problem)) {
        i++
        if (i % 2 === 0) {
          problems.push(problem)
        }
      }
    })

    this.noTeamnumberFinished.forEach(problem => {
      if (!problems.find(p => p === problem)) {
        problems.push(problem)
      }
    })

    return problems.length
  }

  async loadFutureRallyRounds () {
    let rallyRounds = await RallyRound.getAll({})
    rallyRounds = rallyRounds.filter((rallyRound: RallyRound) => {
      if (rallyRound && rallyRound.dateBegin) {
        return rallyRound.dateBegin > new Date().toISOString().slice(0, 19).replace('T', ' ')
      }
    })
    this.futureRallyRounds = rallyRounds
  }

  async loadTeamsizeProblems () {
    const res = await Http.request(`/api/maintenance/finished-members-missing/${this.selectedRallyRound}`)
    this.finishedTeamsizeProblems = await res.json()
  }

  async loadNotFinished () {
    const res = await Http.request(`/api/maintenance/not-finished/${this.selectedRallyRound}`)
    this.notFinished = await res.json()
  }

  async loadDuplicateTeamnumber () {
    const res = await Http.request(`/api/maintenance/duplicate-teamnumbers/${this.selectedRallyRound}`)
    this.duplicateTeamnumbers = await res.json()
  }

  async loadNoTeamnumber () {
    const res = await Http.request(`/api/maintenance/no-teamnumbers/${this.selectedRallyRound}`)
    this.noTeamnumberFinished = await res.json()
  }

  async loadTotalRegistrationNumber () {
    const res = await Http.request(`/api/maintenance/total-registration-number/${this.selectedRallyRound}`)
    this.totalRegistrations = (await res.json()).total
  }
}
